const { Record } = require('immutable')

export default Record({
    error: null,
    fetchCount: 0,
    isFetching: false,
    shouldReload: false,
    dataSource: Record({
        data: [],
        pagination: Record({
            page: 1,
            size: 15,
            totalCount: 0
        })(),
        sorting: Record({
            field: null,
            order: null
        })(),
        filter: Record({
            name: null
        })()
    })()
})